var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-navbars-breadcrumb-index"},[_c('img',{attrs:{"src":require("@/assets/imgs/headerImg.png"),"alt":""}}),_c('p',[_vm._v("基层卫生健康智慧服务平台-业务运营端")]),_c('User')],1)}
var staticRenderFns = []

export { render, staticRenderFns }